angular.module('lsnBase.deprecated.models')
  .factory('PolicyDocumentModel', ['LsnPolicyDocumentModelV1',
    function(LsnPolicyDocumentModelV1) {
      return LsnPolicyDocumentModelV1;
    }
  ]);